module.exports = __webpack_public_path__ + "img/defaultCoinIco.5bf4142f.png";